/**
 * pages.config.js - Page routing configuration
 * 
 * This file is AUTO-GENERATED. Do not add imports or modify PAGES manually.
 * Pages are auto-registered when you create files in the ./pages/ folder.
 * 
 * THE ONLY EDITABLE VALUE: mainPage
 * This controls which page is the landing page (shown when users visit the app).
 * 
 * Example file structure:
 * 
 *   import HomePage from './pages/HomePage';
 *   import Dashboard from './pages/Dashboard';
 *   import Settings from './pages/Settings';
 *   
 *   export const PAGES = {
 *       "HomePage": HomePage,
 *       "Dashboard": Dashboard,
 *       "Settings": Settings,
 *   }
 *   
 *   export const pagesConfig = {
 *       mainPage: "HomePage",
 *       Pages: PAGES,
 *   };
 * 
 * Example with Layout (wraps all pages):
 *
 *   import Home from './pages/Home';
 *   import Settings from './pages/Settings';
 *   import __Layout from './Layout.jsx';
 *
 *   export const PAGES = {
 *       "Home": Home,
 *       "Settings": Settings,
 *   }
 *
 *   export const pagesConfig = {
 *       mainPage: "Home",
 *       Pages: PAGES,
 *       Layout: __Layout,
 *   };
 *
 * To change the main page from HomePage to Dashboard, use find_replace:
 *   Old: mainPage: "HomePage",
 *   New: mainPage: "Dashboard",
 *
 * The mainPage value must match a key in the PAGES object exactly.
 */
import APConsequences from './pages/APConsequences';
import ASDAttendance from './pages/ASDAttendance';
import ASDRoster from './pages/ASDRoster';
import AddStudentsToEA from './pages/AddStudentsToEA';
import AdminDashboard from './pages/AdminDashboard';
import Attendance from './pages/Attendance';
import AttendanceLogs from './pages/AttendanceLogs';
import ConsequenceSettings from './pages/ConsequenceSettings';
import CourtesyExcusals from './pages/CourtesyExcusals';
import DataAdmin from './pages/DataAdmin';
import GradeLevelRoster from './pages/GradeLevelRoster';
import UploadStudents from './pages/UploadStudents';
import StaffManager from './pages/StaffManager';
import IntegrationsHealth from './pages/IntegrationsHealth';
import DrivelineCheck from './pages/DrivelineCheck';
import DrivelineStaff from './pages/DrivelineStaff';
import EAStaff from './pages/EAStaff';
import EAStaffDashboard from './pages/EAStaffDashboard';
import EmailTemplateSettings from './pages/EmailTemplateSettings';
import ExcusalSummary from './pages/ExcusalSummary';
import Home from './pages/Home';
import ImportHistoricalData from './pages/ImportHistoricalData';
import ManageConsequences from './pages/ManageConsequences';
import ManageContent from './pages/ManageContent';
import ManageTickets from './pages/ManageTickets';
import Reports from './pages/Reports';
import RestoreData from './pages/RestoreData';
import RunningRoster from './pages/RunningRoster';
import Settings from './pages/Settings';
import StudentAnnouncements from './pages/StudentAnnouncements';
import StudentDashboard from './pages/StudentDashboard';
import StudentGuidelines from './pages/StudentGuidelines';
import Students from './pages/Students';
import SubmitTicket from './pages/SubmitTicket';
import TeacherAnnouncements from './pages/TeacherAnnouncements';
import TeacherDashboard from './pages/TeacherDashboard';
import TeacherExcusals from './pages/TeacherExcusals';
import TeacherRoster from './pages/TeacherRoster';
import Teachers from './pages/Teachers';
import Users from './pages/Users';
import __Layout from './Layout.jsx';


export const PAGES = {
    "APConsequences": APConsequences,
    "ASDAttendance": ASDAttendance,
    "ASDRoster": ASDRoster,
    "AddStudentsToEA": AddStudentsToEA,
    "AdminDashboard": AdminDashboard,
    "Attendance": Attendance,
    "AttendanceLogs": AttendanceLogs,
    "ConsequenceSettings": ConsequenceSettings,
    "CourtesyExcusals": CourtesyExcusals,
    "DataAdmin": DataAdmin,
    "UploadStudents": UploadStudents,
    "StaffManager": StaffManager,
    "IntegrationsHealth": IntegrationsHealth,
    "DrivelineCheck": DrivelineCheck,
    "DrivelineStaff": DrivelineStaff,
    "EAStaff": EAStaff,
    "EAStaffDashboard": EAStaffDashboard,
    "EmailTemplateSettings": EmailTemplateSettings,
    "ExcusalSummary": ExcusalSummary,
    "GradeLevelRoster": GradeLevelRoster,
    "Home": Home,
    "ImportHistoricalData": ImportHistoricalData,
    "ManageConsequences": ManageConsequences,
    "ManageContent": ManageContent,
    "ManageTickets": ManageTickets,
    "Reports": Reports,
    "RestoreData": RestoreData,
    "RunningRoster": RunningRoster,
    "Settings": Settings,
    "StudentAnnouncements": StudentAnnouncements,
    "StudentDashboard": StudentDashboard,
    "StudentGuidelines": StudentGuidelines,
    "Students": Students,
    "SubmitTicket": SubmitTicket,
    "TeacherAnnouncements": TeacherAnnouncements,
    "TeacherDashboard": TeacherDashboard,
    "TeacherExcusals": TeacherExcusals,
    "TeacherRoster": TeacherRoster,
    "Teachers": Teachers,
    "Users": Users,
}

export const pagesConfig = {
    mainPage: "AdminDashboard",
    Pages: PAGES,
    Layout: __Layout,
};